<div id="bucket-container">
  <ng-content></ng-content>
</div>
